import React, { useContext, useEffect, useState } from "react";

import "../../css/Profile/Profile.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { domain } from "../Links/Links";
import { AuthContext } from "../SessionChecker/SessionChecker";
import { useTranslation } from "react-i18next";
import { DB_NAME, DB_VERSION, STORE_NAME } from "../IndexDB/IndexDB";
import { ProfileMenu } from "./ProfileMenu";
import { profileRequest } from "./ProfileRequest";
import Order from "./Order";
import { profileLoading } from "./ProfileLoading";
import { requestToExtractProducts } from "../Products/AddProduct/RequestToExtractProducts";

const openProductsDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, {
          keyPath: "id",
        });
      }
    };

    request.onsuccess = () => {
      resolve(request.result);
    };

    request.onerror = () => {
      reject(request.error);
    };
  });
};

const getCachedProducts = async () => {
  try {
    const db = await openProductsDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, "readonly");

      const store = transaction.objectStore(STORE_NAME);

      const request = store.getAll();

      request.onsuccess = () => {
        resolve(request.result || []);
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  } catch (error) {
    console.error("IndexedDB read error:", error);

    return [];
  }
};

const convertCachedImagesToUrls = (products) => {
  return products.map((product) => {
    const images = product.images || [];

    return {
      ...product,

      images: images.map((image) => {
        if (image instanceof Blob) {
          return URL.createObjectURL(image);
        }

        return image;
      }),
    };
  });
};

const saveProductsToCache = async (products) => {
  try {
    const db = await openProductsDB();

    const productsWithBlobs = await Promise.all(
      products.map(async (product) => {
        const images = product.images || [];

        const blobImages = await Promise.all(
          images.map(async (imageUrl) => {
            try {
              const response = await fetch(imageUrl);

              if (!response.ok) {
                throw new Error(`Failed to fetch image: ${imageUrl}`);
              }

              const blob = await response.blob();

              return blob;
            } catch (error) {
              console.error("Image cache error:", imageUrl, error);

              return null;
            }
          }),
        );

        return {
          ...product,

          images: blobImages.filter(Boolean),
        };
      }),
    );

    await new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, "readwrite");

      const store = transaction.objectStore(STORE_NAME);

      store.clear();

      productsWithBlobs.forEach((product) => {
        store.put(product);
      });

      transaction.oncomplete = resolve;

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });

    return productsWithBlobs;
  } catch (error) {
    console.error("IndexedDB write error:", error);

    return [];
  }
};

function Profile({ theme, setTheme }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const [profileData, setProfileData] = useState([]);

  const navigate = useNavigate();

  const [orderStatus, setOrderStatus] = useState(false);

  const { sessionStatus, currentUserUsername, tick } = useContext(AuthContext);

  const [profileMenuStatus, setProfileMenuStatus] = useState(false);

  const { username } = useParams();

  const [productsData, setProductsData] = useState([]);

  console.log(username);

  useEffect(() => {
    if (!currentUserUsername) {
      setLoading(false);

      return;
    }

    profileRequest(username, setProfileData, setLoading);

    requestToExtractProducts(setProductsData);
  }, [username]);

  useEffect(() => {
    document.title = `@${profileData[0]?.username}`;
  }, [profileData]);

  return (
    <div className={`mainDiv ${theme}`}>
      <div className={`headerDiv ${theme}`}>
        <div className="usernameDiv">
          {sessionStatus ? (
            <>
              <div>{currentUserUsername}</div>
              {tick == true ? (
                <div className="tickDiv">
                  <img src="/icons/green_tick.png"></img>
                </div>
              ) : null}
            </>
          ) : (
            <button
              className="signinButton"
              onClick={() => {
                navigate("/signin");
              }}
            >
              {t("Signin")}
            </button>
          )}
        </div>

        <div className="empty_center_div"></div>

        <button
          className={`iconButton ${theme}`}
          onClick={() => {
            navigate("/shopping_cart");
          }}
        >
          <img src="/icons/shopping_cart.png"></img>
        </button>

        <button
          className={`iconButton ${theme}`}
          onClick={() => {
            setProfileMenuStatus(true);
          }}
        >
          <img src="/icons/menu.png"></img>
        </button>

        {profileMenuStatus && (
          <ProfileMenu
            theme={theme}
            setProfileMenuStatus={setProfileMenuStatus}
            setTheme={setTheme}
          ></ProfileMenu>
        )}
      </div>

      <div className="contentDiv padding12 gap12">
        {loading ? (
          profileLoading(theme)
        ) : sessionStatus ? (
          <>
            <div className="profileHeader">
              <div className="profileUser">
                <div className="profileAvatar">
                  {profileData[0]?.username.charAt(0).toUpperCase()}
                </div>

                <div className="profileUserInfo">
                  <div>@{profileData[0]?.username}</div> 

                  <div>
                    {productsData.length} {t("Products")}
                  </div>
                </div>
              </div>

              <button className={`profileWalletButton ${theme}`} onClick={() => {
                navigate('/shared_wallet')
              }}>
                <img src="/icons/wallet.png"></img>
                <div className="">{t('Wallet')}</div>
              </button>
            </div>

            {profileData[0]?.username != currentUserUsername && (
              <div className="profileButtonsDiv">
                <button
                  className="profileButton"
                  onClick={() => {
                    setOrderStatus(true);
                  }}
                >
                  {t("Order")}
                </button>

                <button
                  className="profileButton"
                  onClick={() => {
                    setOrderStatus(true);
                  }}
                >
                  {t("Follow")}
                </button>
              </div>
            )}

            {orderStatus && (
              <Order
                theme={theme}
                setOrderStatus={setOrderStatus}
                username={username}
              ></Order>
            )}

            <div className="productsDiv">
              {productsData.length === 0 ? (
                <div className="emptyDiv">
                  <img src="/images/empty512.png"></img>
                  <div className="emptyTitleDiv">{t("Empty")}</div>
                </div>
              ) : (
                productsData.map((product) => {
                  const images = product.images || [];

                  return (
                    <div
                      className="productPreviewDiv"
                      key={product.id}
                      onClick={() => {
                        navigate("/p/" + product.link);
                      }}
                    >
                      <div className="productDataDiv">
                        <div className="productImageSlider">
                          <img
                            src={product.image}
                            className="productImage"
                            loading="lazy"
                            decoding="async"
                          ></img>
                        </div>
                        <div className="productInfoDivInProductPreview">
                          <div>
                            {product.name?.length > 20
                              ? product.name.slice(0, 20) + "..."
                              : product.name}
                          </div>

                          <div className="productPrice">
                            {Number(product.price).toLocaleString()} {product.price_type}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </>
        ) : (
          <div className="signinMessage">
            {t("Signin to view this section")}
          </div>
        )}
      </div>
    </div>
  );
}

export default Profile;
